import { NonEmptyArray } from "../../shared/types";
import { cn } from "../lib/utils";

export type CategoryFilterOption<TFilterOption> = NonEmptyArray<{
	id: TFilterOption;
	label: string;
}>;

type CategoryFiltersProps<TFilterOption> = {
	filterOptions: CategoryFilterOption<TFilterOption>;
	categoryFilter: TFilterOption;
	setCategoryFilter: (categoryFilter: TFilterOption) => void;
};

export const CategoryFilters = <TFilterOption extends string>({
	filterOptions,
	categoryFilter,
	setCategoryFilter,
}: CategoryFiltersProps<TFilterOption>) => {
	return (
		<div className="flex flex-wrap gap-2" role="tablist" aria-label="Document category filter">
			{filterOptions.map((option) => (
				<button
					key={option.id}
					type="button"
					role="tab"
					aria-selected={categoryFilter === option.id}
					className={cn(
						"rounded-full px-2.5 py-1 text-xs font-medium",
						categoryFilter === option.id
							? "bg-primary text-white"
							: "border border-bc-default bg-surface-base text-secondary",
					)}
					onClick={() => setCategoryFilter(option.id)}
				>
					{option.label}
				</button>
			))}
		</div>
	);
};
